import './services.scss';
import 'nodelist-foreach-polyfill';
import anime from 'animejs/lib/anime.es';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-services-item]').forEach((servicesItem) => {
    const servicesLink = servicesItem.querySelector('[data-services-link]');
    const servicesContent = document.querySelector('[data-services-content]');
    const servicesOverlay = document.querySelector('[data-services-overlay]');
    const servicesClose = document.querySelector('[data-services-close]');

    function close() {
      servicesItem.classList.remove('opened');
      anime({
        targets: servicesOverlay,
        translateX: ['0', '16px'],
        opacity: [1, 0],
        duration: 500,
        easing: 'linear',
        complete() {
          servicesOverlay.style.display = 'none';
        },
      });
    }

    servicesLink.addEventListener('click', (e) => {
      e.preventDefault();

      if (servicesItem.classList.contains('opened')) {
        servicesItem.classList.remove('opened');
      } else {
        servicesItem.classList.add('opened');
      }
      servicesContent.innerHTML = servicesItem.innerHTML;

      servicesOverlay.style.display = 'block';
      anime({
        targets: servicesOverlay,
        translateX: ['16px', '0'],
        opacity: [0, 1],
        duration: 500,
        easing: 'linear',
      });
    });

    servicesClose.addEventListener('click', () => {
      close();
    });

    servicesOverlay.addEventListener('click', (e) => {
      if (!servicesContent.contains(e.target)) {
        close();
      }
    });

    window.addEventListener('keydown', (e) => {
      switch (e.keyCode) {
        case 27:
          close();
          break;
        default: //
      }
    });
  });
});
